import { Box, Text } from 'ink';
import { BreakpointPlan } from '../commands/build/utilities/types';
import { formatResolvedQueueMessage } from '../commands/build/utilities/breakpoints';

export interface BreakpointNoticeProps {
  plan?: BreakpointPlan;
}

export default function BreakpointNotice({ plan }: BreakpointNoticeProps) {
  if (!plan) {
    return null;
  }

  const lines = formatResolvedQueueMessage(
    plan.breakpoints,
    plan.warnings,
    plan.expansions,
  );

  return (
    <Box flexDirection="column" marginBottom={1}>
      {lines.map((line) => (
        <Text key={line}>{line}</Text>
      ))}
    </Box>
  );
}
